<script>
import { ref, onMounted, onBeforeUnmount, onUpdated } from 'vue';
import ReactDOM from 'react-dom';
import React from 'react';
import Loading from '@/rex-components/rex-loading.vue';
import NoData from '@/rex-components/rex-no-data.vue';
import BuildConfig from '@/environment';

const firstLoad = new Promise((resolve) => setTimeout(resolve, 1000));
async function fetchDigitalExperience() {
  // simulate long network delay
  await firstLoad;

  // uncomment to simulate failed load
  // throw new Error("Failed to load button from remote.");
  const module = await import('user/App');
  return module.default;
}

export default {
  name: 'DigitalExperienceReactApp',
  props: {
    permissions: {},
  },
  components: {
    Loading,
    NoData,
  },
  data() {
    return {
      noDataErrMessage: this.$t('errorLoadingDx'),
      disableDX: BuildConfig.VUE_APP_DISABLE_DX,
    };
  },
  setup(props) {
    const root = ref(null);
    const error = ref(null);
    const moduleError = ref(false);
    const DigitalExperienceReactComponent = ref(null);

    function updateReactComponent() {
      if (!DigitalExperienceReactComponent.value || !!error.value) return;

      ReactDOM.render(
        React.createElement(DigitalExperienceReactComponent.value, props),
        root.value,
      );
    }
    function unmountReactComponent() {
      root.value && ReactDOM.unmountComponentAtNode(root.value);
    }

    onMounted(updateReactComponent);
    onUpdated(updateReactComponent);
    onBeforeUnmount(unmountReactComponent);

    fetchDigitalExperience()
      .then((b) => {
        if (!b) {
          moduleError.value = true;
        }
        DigitalExperienceReactComponent.value = b;
        updateReactComponent();
      })
      .catch((e) => {
        error.value = '12';
      });

    return { root, error, moduleError };
  },
};
</script>
<template>
  <!-- this element is just served to mount the React element  -->
  <div v-if="error || disableDX === 'true' || moduleError">
    <NoData :message="noDataErrMessage" class="noData" />
  </div>
  <div v-else ref="root">
    <Loading class="infinite-loader" />
  </div>
</template>
<style scoped>
.infinite-loader {
  padding: 0.25rem 0 0.75rem 0;
  height: 84vh;
}
.noData {
  height: 84vh;
}
</style>
